


function TermsPage(){
    return (
     <p style={{margin: "2vw", fontSize: "large"}}>
    <strong>SMS Terms and Conditions</strong> <br/><br/>
     BBCO2, LLC Informational Alerts. Message Frequency Varies. Message and Data Rates May Apply. Reply STOP to stop. Reply HELP for info or you can reach us at SalinasBroadwaybingo@gmail.com or (831) 455-8224. Carriers are not liable for delayed or undelivered messages.<br/><br/>

    <strong>Privacy Policy</strong> <br/><br/>
     BBCO2, LLC respects your privacy. We will not share or use your mobile number for any other purpose. We will only use information you provide to transmit your text message. Nonetheless, we reserve the right at all times to disclose any information as necessary to satisfy any law, regulation or governmental request, to avoid liability, or to protect our rights or property. When you complete forms online or otherwise provide us information in connection with the Service, you agree to provide accurate, complete and true information. You agree not to use a false or misleading name or a name that you are not authorized to use. If we, in our sole discretion, believe that any such information is untrue, inaccurate or incomplete, we may refuse you access to the Service and pursue any appropriate legal remedies.<br/><br/>
     
    </p>
    )
}

export default TermsPage;